import { createRoot } from "react-dom/client";
import { LayersIcon } from "../../../Assets/icons/LayersIcon";
import { globeStyles } from "../../../utils/constant";
import globe from "../../../Assets/images/earth.png";
import mapIcon from "../../../Assets/images/location.png";

export const MapLayers = (setBaseStyle, currentBaseStyle) => {
  const mapStyles = globeStyles;

  return {
    onAdd(map) {
      this.map = map;

      this.container = document.createElement("div");
      this.container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      this.container.style.position = "relative";
      this.container.style.cursor = "pointer";
      this.container.style.padding = "13px";

      const toggleBtn = document.createElement("div");
      toggleBtn.title = "Layers";
      this.container.appendChild(toggleBtn);
      const root = createRoot(toggleBtn);
      root.render(<LayersIcon />);

      const dropdown = document.createElement("div");
      dropdown.style.display = "none";
      dropdown.style.position = "absolute";
      dropdown.style.background = "rgba(255, 255, 255, 0.75)";
      dropdown.style.borderRadius = "4px";
      dropdown.style.padding = "8px";
      dropdown.style.zIndex = "999";
      dropdown.style.top = 0;
      dropdown.style.left = "-180px";

      const buttons = [];

      const updateHighlight = (selected) => {
        buttons.forEach(({ btn, name }) => {
          btn.style.background = name === selected ? "#ffe79b" : "";
        });
      };

      mapStyles.forEach(({ id, icon, name }) => {
        const btn = document.createElement("button");
        const root = createRoot(btn);
        root.render(<img src={icon} alt={id} width={26} height={26} />);
        btn.title = id;
        btn.style.display = "flex";
        btn.style.alignItems = "center";
        btn.style.justifyContent = "center";
        btn.style.width = "100%";
        btn.style.border = "none";
        btn.style.background = "transparent";
        btn.style.padding = "3px";
        btn.style.margin = "3px 0";
        btn.style.cursor = "pointer";

        btn.onclick = (e) => {
          e.stopPropagation();
          setBaseStyle(name);
          localStorage.setItem("baseStyle", name);
          updateHighlight(name);
          dropdown.style.display = "none";
        };

        dropdown.appendChild(btn);
        buttons.push({ btn, name });
      });

      updateHighlight(currentBaseStyle);
      this.container.appendChild(dropdown);

      this.container.onclick = () => {
        dropdown.style.display =
          dropdown.style.display === "none" ? "flex" : "none";
      };

      return this.container;
    },

    onRemove() {
      this.container.parentNode.removeChild(this.container);
      this.map = undefined;
    },
  };
};

export class ToggleStyleControl {
  constructor(toggleHandler, initial3D = false) {
    this._map = null;
    this._container = null;
    this._toggleHandler = toggleHandler;
    this._is3D = initial3D;
    this._root = null;
  }

  _renderIcon(button) {
    if (!this._root) {
      this._root = createRoot(button);
    }
    this._root.render(
      <img
        src={this._is3D ? globe : mapIcon}
        alt={this._is3D ? "Globe view" : "Flat view"}
        width={26}
        height={26}
      />
    );
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl toggle-3d-ctrl";

    const button = document.createElement("button");
    button.className = "toggle-button";
    button.title = "Toggle between 2D and 3D";

    // initial render
    this._renderIcon(button);

    // handle toggle
    button.onclick = () => {
      this._is3D = !this._is3D;
      this._renderIcon(button);
      if (this._toggleHandler) this._toggleHandler(this._is3D);
    };

    this._container.appendChild(button);
    return this._container;
  }

  onRemove() {
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
    this._map = undefined;
  }
}
